export default "__VITE_ASSET__4is_vy7Z__"